// import React, { useEffect, useState } from "react";
// import { Redirect, Route, Switch } from "react-router-dom";
// import { activateGeod, closeGeod } from "../Store";
// import { Routes } from "../routes";
// import { connect } from "react-redux";
// import swal from "sweetalert";
// import DashboardOverview from "./dashboard/DashboardOverview";
// // --- components
// import Footer from "../components/Footer";
// import Navbar from "../components/Navbar";
// import Preloader from "../components/Preloader";
// import Sidebar from "../components/Sidebar";

// // --- examples
// import ForgotPassword from "./examples/ForgotPassword";
// import NotFoundPage from "./examples/NotFound";
// import ResetPassword from "./examples/ResetPassword";
// import ServerError from "./examples/ServerError";
// import SignMobile from "./examples/SignMobile";
// import SignOtp from "./examples/SignOtp";
// import Signin from "./examples/Signin";
// // --- master Module
// import AccessControlTabs from "./master/AccessControl/AccessControlTabs";
// import CustomerEntry from "./master/CustomerEntry";
// import CustomerEntryReports from "./master/CustomerEntryReports";
// import DealerEntry from "./master/DealerEntry";
// import DealerEntryReports from "./master/DealerEntryReports";
// import UserEntry from "./master/UserEntry";
// import UserEntryReports from "./master/UserEntryReports";
// // --- production Module
// import AddProduction from "./production/AddProduction";
// import ProductionList from "./production/ProductionList";
// // --- dispatch
// import AddDispatch from "./dispatch/AddDispatch";
// import DispatchList from "./dispatch/DispatchList";
// // --- work order
// import Calibration from "./work-order/Calibration";
// import CalibrationList from "./work-order/CalibrationList";
// import FieldJob from "./work-order/FieldJob";
// import FieldJobList from "./work-order/FieldJobList";
// import Installation from "./work-order/Installation";
// import InstallationList from "./work-order/InstallationList";
// // --- service Module
// import ARKFailedCalibrationList from "./serviceModule/ARKFailedCalibrationList";
// import ArkCalibrationList from "./serviceModule/ArkCalibrationList";
// import ArkFieldList from "./serviceModule/ArkFieldList";
// import EndingARKCalibration from "./serviceModule/EndingARKCalibration";
// import GetCalibrationDispenser from "./serviceModule/GetCalibrationDispenser";
// import GetDispenser from "./serviceModule/GetDispenser";
// import GetFieldDispenser from "./serviceModule/GetFieldDispenser";
// import ListOfCalibration from "./serviceModule/ListOfCalibration";
// import ListOfInstallation from "./serviceModule/ListOfInstallation";
// import ListofFieldIssue from "./serviceModule/ListofFieldIssue";
// import VerificationCalibrationList from "./serviceModule/VerificationCalibrationList";
// import VerificationFieldIssueList from "./serviceModule/VerificationFieldIssueList";
// import VerificationInstallationList from "./serviceModule/VerificationInstallationList";
// // --- reports
// import AllReportsTab from "./reports/AllReportsTab";
// import DispatchWiseTab from "./reports/DispatchWiseTab";
// import DispenserRecordTab from "./reports/DispenserRecordTab";
// // import ProductTab from "./reports/ProductTab";
// import ServicesTab from "./reports/ServicesTab";
// import WorkOrderTab from "./reports/WorkOrderTab";
// import AboutUs from "../pages/examples/AboutUs";
// import NonTechDashboard from "../pages/TicketServiceComp/TicketServiceDashboardComp/TicketnonTechDashboard"
// import TechDashboard from "../pages/TicketServiceComp/TicketServiceDashboardComp/TicketTechDashbaord";
// import TicketServiceNonTech from "../pages/TicketServiceComp/TicketServiceNonTech";
// import RaiseTicketForm from "../pages/TicketServiceComp/RaiseTicket"
// import TicketServiceTech from "../pages/TicketServiceComp/TicketServiceTech";
// import ROCreate from "../pages/TicketServiceComp/RoOnboardingComp/ROCreate";
// import RoGetlist from "../pages/TicketServiceComp/RoOnboardingComp/RoGetlist";
// import axios from "axios";
// import { useHistory } from "react-router-dom";
// const isAuthenticated = (reduxprops) => {
//   if (reduxprops?.geod?.title) {
//     return true;
//   } else {
//     return false;
//   }
// };

// const isPermission = (accessLabel) => {
//   if (sessionStorage.getItem("moduleName") !== null) {
//     const moduleName = sessionStorage.getItem("moduleName");
//     const modules = moduleName.split(",");
//     const withOutSpace = modules.map((item) => item.trimStart());
//     return withOutSpace.includes(accessLabel);
//   }
// };



// const RouteWithLoader = ({ component: Component, reduxprops, ...rest }) => {
//   const [loaded, setLoaded] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => setLoaded(true), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         !isAuthenticated(reduxprops) ? (
//           <>
//             {" "}
//             <Preloader show={loaded ? false : true} /> <Component {...props} />{" "}
//           </>
//         ) : (
//           <Redirect to="/" />
//         )
//       }
//     />
//   );
// };

// const RouteWithSidebar = ({
//   component: Component,
//   reduxprops,
//   accessLabel,
//   ...rest
// }) => {
//   const [loaded, setLoaded] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => setLoaded(true), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   const sessionStorageIsSettingsVisible = () => {
//     return sessionStorage.getItem("settingsVisible") === "false" ? false : true;
//   };

//   const [showSettings, setShowSettings] = useState(
//     sessionStorageIsSettingsVisible
//   );

//   const toggleSettings = () => {
//     setShowSettings(!showSettings);
//     sessionStorage.setItem("settingsVisible", !showSettings);
//   };

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isAuthenticated(reduxprops) ? (
//           isPermission(accessLabel) ? (
//             <>
//               {/* <Preloader show={loaded ? false : true} /> */}
//               <Sidebar />
//               <main className="content">
//                 <Navbar />
//                 <Component {...props} />
//                 <Footer
//                   toggleSettings={toggleSettings}
//                   showSettings={showSettings}
//                 />
//               </main>
//             </>
//           ) : (
//             <Redirect to={Routes.NotFound.path} />
//             // <Redirect to={Routes.Signin.path} />
//           )
//         ) : (
//           <Redirect to={Routes.Signin.path} />
//         )
//       }
//     />
//   );
// };
// const RouteWithNavbar = ({
//   component: Component,
//   reduxprops,
//   accessLabel,
//   ...rest
// }) => {
//   const [loaded, setLoaded] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => setLoaded(true), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   const sessionStorageIsSettingsVisible = () => {
//     return sessionStorage.getItem("settingsVisible") === "false" ? false : true;
//   };

//   const [showSettings, setShowSettings] = useState(
//     sessionStorageIsSettingsVisible
//   );

//   const toggleSettings = () => {
//     setShowSettings(!showSettings);
//     sessionStorage.setItem("settingsVisible", !showSettings);
//   };

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isAuthenticated(reduxprops) ? (
//           isPermission ? (
//             <>

//               <Sidebar />
//               <main className="content">
//                 <Navbar />
//                 <Component {...props} />
//                 <Footer
//                   toggleSettings={toggleSettings}
//                   showSettings={showSettings}
//                 />
//               </main>
//             </>
//           ) : (
//             <Redirect to={Routes.NotFound.path} />
//             // <Redirect to={Routes.Signin.path} />
//           )
//         ) : (
//           <Redirect to={Routes.Signin.path} />
//         )
//       }
//     />
//   );
// };

// const HomePage = (props) => {


//   // const history = useHistory(); 

//   // useEffect(() => {
   
//   //   window.history.pushState(null, null, window.location.href);
//   //   window.onpopstate = () => {
//   //     window.history.go(1); // prevent user to go back 
//   //   };
//   // }, [history]);

  
//   return (
//     <>
   
//       <Switch>
//         <RouteWithLoader
//           exact
//           path={Routes.Signin.path}
//           reduxprops={props}
//           component={Signin}
//         />
//         <RouteWithLoader
//           exact
//           path={Routes.SignMobile.path}
//           reduxprops={props}
//           component={SignMobile}
//         />
//         <RouteWithLoader
//           exact
//           path={Routes.ForgotPassword.path}
//           reduxprops={props}
//           component={ForgotPassword}
//         />
//         <RouteWithLoader
//           exact
//           path={Routes.ResetPassword.path}
//           reduxprops={props}
//           component={ResetPassword}
//         />
//         <RouteWithLoader
//           exact
//           path={Routes.SignOtp.path}
//           reduxprops={props}
//           component={SignOtp}
//         />
//         <Route
//           exact
//           path={Routes.NotFound.path}
//           reduxprops={props}
//           component={NotFoundPage}
//         />
//         <RouteWithLoader
//           exact
//           path={Routes.ServerError.path}
//           reduxprops={props}
//           component={ServerError}
//         />
//         <RouteWithNavbar
//           exact
//           path={Routes.AboutUs.path}
//           reduxprops={props}
//           component={AboutUs}

//         />
//         {/* --------------------------------------------------------------- master */}
//         <RouteWithSidebar
//           exact
//           path={Routes.AccessControlTabs.path}
//           component={AccessControlTabs}
//           reduxprops={props}
//           accessLabel="Access Control"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.CustomerEntryReports.path}
//           reduxprops={props}
//           component={CustomerEntryReports}
//           accessLabel="Customer Entry"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.CustomerEntry.path}
//           reduxprops={props}
//           component={CustomerEntry}
//           accessLabel="Customer Entry"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.DealerEntryReports.path}
//           reduxprops={props}
//           component={DealerEntryReports}
//           accessLabel="Dealer Entry"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.DealerEntry.path}
//           reduxprops={props}
//           component={DealerEntry}
//           accessLabel="Dealer Entry"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.UserEntryReports.path}
//           reduxprops={props}
//           component={UserEntryReports}
//           accessLabel="User Entry"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.UserEntry.path}
//           reduxprops={props}
//           component={UserEntry}
//           accessLabel="User Entry"
//         />

//         {/* --------------------------------------------------------------- production */}
//         <RouteWithSidebar
//           exact
//           path={Routes.ProductionList.path}
//           reduxprops={props}
//           component={ProductionList}
//           accessLabel="Production"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.AddProduction.path}
//           reduxprops={props}
//           component={AddProduction}
//           accessLabel="Production"
//         />

//         {/* --------------------------------------------------------------- dispatch */}
//         <RouteWithSidebar
//           exact
//           path={Routes.DispatchList.path}
//           reduxprops={props}
//           component={DispatchList}
//           accessLabel="Dispatch"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.AddDispatch.path}
//           reduxprops={props}
//           component={AddDispatch}
//           accessLabel="Dispatch"
//         />

//         {/* --------------------------------------------------------------- work order */}
//         <RouteWithSidebar
//           exact
//           path={Routes.InstallationList.path}
//           reduxprops={props}
//           component={InstallationList}
//           accessLabel="WOInstall"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.Installation.path}
//           reduxprops={props}
//           component={Installation}
//           accessLabel="WOInstall"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.FieldJobList.path}
//           reduxprops={props}
//           component={FieldJobList}
//           accessLabel="WOField Issue"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.FieldJob.path}
//           reduxprops={props}
//           component={FieldJob}
//           accessLabel="WOField Issue"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.CalibrationList.path}
//           reduxprops={props}
//           component={CalibrationList}
//           accessLabel="WOCalibration"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.Calibration.path}
//           reduxprops={props}
//           component={Calibration}
//           accessLabel="WOCalibration"
//         />

//         {/* --------------------------------------------------------------- services */}
//         <RouteWithSidebar
//           exact
//           path={Routes.ListOfInstallation.path}
//           reduxprops={props}
//           component={ListOfInstallation}
//           accessLabel="SEInstall"
//         />

//         <RouteWithSidebar
//           exact
//           path={Routes.GetDispenser.path}
//           reduxprops={props}
//           component={GetDispenser}
//           accessLabel="SEInstall"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.ListofFieldIssue.path}
//           reduxprops={props}
//           component={ListofFieldIssue}
//           // accessLabel="SEField Issue"
//           accessLabel="SEField Job"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.GetFieldDispenser.path}
//           reduxprops={props}
//           component={GetFieldDispenser}
//           // accessLabel="SEField Issue"
//           accessLabel="SEField Job"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.VerificationFieldIssueList.path}
//           reduxprops={props}
//           component={VerificationFieldIssueList}
//           accessLabel="SECalibration"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.ListOfCalibration.path}
//           reduxprops={props}
//           component={ListOfCalibration}
//           accessLabel="SECalibration"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.GetCalibrationDispenser.path}
//           reduxprops={props}
//           component={GetCalibrationDispenser}
//           accessLabel="SECalibration"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.VerificationCalibrationList.path}
//           reduxprops={props}
//           component={VerificationCalibrationList}
//           accessLabel="SECalibration"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.ArkCalibrationList.path}
//           reduxprops={props}
//           component={ArkCalibrationList}
//           accessLabel="SECalibration"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.ARKFailedCalibrationList.path}
//           reduxprops={props}
//           component={ARKFailedCalibrationList}
//           accessLabel="SECalibration"
//         />

//         <RouteWithSidebar
//           exact
//           path={Routes.VerificationInstallationList.path}
//           reduxprops={props}
//           component={VerificationInstallationList}
//           accessLabel="SEInstall"
//         />

//         <RouteWithSidebar
//           exact
//           path={Routes.ArkFieldList.path}
//           reduxprops={props}
//           component={ArkFieldList}
//           // accessLabel="SEField Issue"
//           accessLabel="SEField Job"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.EndingARKCalibration.path}
//           reduxprops={props}
//           component={EndingARKCalibration}
//           accessLabel="SECalibration"
//         />
//         {/* Reports */}
//         <RouteWithSidebar
//           exact
//           path={Routes.AllReportsTab.path}
//           component={AllReportsTab}
//           reduxprops={props}
//           accessLabel="REMaster"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.DispatchWiseTab.path}
//           component={DispatchWiseTab}
//           reduxprops={props}
//           accessLabel="REDispatch"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.WorkOrderTab.path}
//           component={WorkOrderTab}
//           reduxprops={props}
//           accessLabel="REWorkOrder"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.ServicesTab.path}
//           component={ServicesTab}
//           reduxprops={props}
//           accessLabel="REServices"
//         />
//         <RouteWithSidebar
//           exact
//           path={Routes.DispenserRecordTab.path}
//           component={DispenserRecordTab}
//           reduxprops={props}
//           accessLabel="REDispBoa"
//         />

//         <RouteWithSidebar
//           exact
//           path={Routes.NonTechDashboard.path}
//           component={NonTechDashboard}
//           reduxprops={props}
//           accessLabel="nontech dashbaord"
//         />

//          <RouteWithSidebar
//           exact
//           path={Routes.TechDashboard.path}
//           component={TechDashboard}
//           reduxprops={props}
//           accessLabel="tech dashboard"
//         />

//           <RouteWithSidebar
//           exact
//           path={Routes.TicketServiceNonTech.path}
//           component={TicketServiceNonTech}
//           reduxprops={props}
//           accessLabel="nontech service"
//         />

//            <RouteWithSidebar
//           exact
//           path={Routes.RaiseTicketForm.path}
//           component={RaiseTicketForm}
//           reduxprops={props}
//           accessLabel="nontech service"
//         />

//           <RouteWithSidebar
//           exact
//           path={Routes.TicketServiceTech.path}
//           component={TicketServiceTech}
//           reduxprops={props}
//           accessLabel="tech service"
//         />

//         {/* 
        
//         */}


//          <RouteWithSidebar
//           exact
//           path={Routes.RoOnboarding.path}
//           component={ROCreate}
//           reduxprops={props}
//           accessLabel="Ro onboard"
//         />

//          <RouteWithSidebar
//           exact
//           path={Routes.RoList.path}
//           component={RoGetlist}
//           reduxprops={props}
//           accessLabel="Ro List"
//         />

//         {/* pages */}
//         <RouteWithSidebar
//           exact
//           path={Routes.DashboardOverview.path}
//           reduxprops={props}
//           component={DashboardOverview}
//           accessLabel="Dashboard"
//         />
//         <Redirect to={Routes.NotFound.path} />

        
//       </Switch>

//     </>
//   );
// };

// const mapStateToProps = (state) => {
//   return {
//     geod: state.geod,
//   };
// };

// const mapDispatchToProps = {
//   activateGeod,
//   closeGeod,
// };

// const AppContainer = connect(mapStateToProps, mapDispatchToProps)(HomePage);

// export default AppContainer;



import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { activateGeod, closeGeod } from "../Store";
import { Routes } from "../routes";
import { connect } from "react-redux";
import swal from "sweetalert";
import DashboardOverview from "./dashboard/DashboardOverview";
// --- components
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Preloader from "../components/Preloader";
import Sidebar from "../components/Sidebar";

// --- examples
import ForgotPassword from "./examples/ForgotPassword";
import NotFoundPage from "./examples/NotFound";
import ResetPassword from "./examples/ResetPassword";
import ServerError from "./examples/ServerError";
import SignMobile from "./examples/SignMobile";
import SignOtp from "./examples/SignOtp";
import Signin from "./examples/Signin";
// --- master Module
import AccessControlTabs from "./master/AccessControl/AccessControlTabs";
import CustomerEntry from "./master/CustomerEntry";
import CustomerEntryReports from "./master/CustomerEntryReports";
import DealerEntry from "./master/DealerEntry";
import DealerEntryReports from "./master/DealerEntryReports";
import UserEntry from "./master/UserEntry";
import UserEntryReports from "./master/UserEntryReports";
// --- production Module
import AddProduction from "./production/AddProduction";
import ProductionList from "./production/ProductionList";
// --- dispatch
import AddDispatch from "./dispatch/AddDispatch";
import DispatchList from "./dispatch/DispatchList";
// --- work order
import Calibration from "./work-order/Calibration";
import CalibrationList from "./work-order/CalibrationList";
import FieldJob from "./work-order/FieldJob";
import FieldJobList from "./work-order/FieldJobList";
import Installation from "./work-order/Installation";
import InstallationList from "./work-order/InstallationList";
// --- service Module
import ARKFailedCalibrationList from "./serviceModule/ARKFailedCalibrationList";
import ArkCalibrationList from "./serviceModule/ArkCalibrationList";
import ArkFieldList from "./serviceModule/ArkFieldList";
import EndingARKCalibration from "./serviceModule/EndingARKCalibration";
import GetCalibrationDispenser from "./serviceModule/GetCalibrationDispenser";
import GetDispenser from "./serviceModule/GetDispenser";
import GetFieldDispenser from "./serviceModule/GetFieldDispenser";
import ListOfCalibration from "./serviceModule/ListOfCalibration";
import ListOfInstallation from "./serviceModule/ListOfInstallation";
import ListofFieldIssue from "./serviceModule/ListofFieldIssue";
import VerificationCalibrationList from "./serviceModule/VerificationCalibrationList";
import VerificationFieldIssueList from "./serviceModule/VerificationFieldIssueList";
import VerificationInstallationList from "./serviceModule/VerificationInstallationList";
//sales tool
import Configutar from "../pages/SalesComponent/Quote/Configutar";
import salesAddComponent from "../pages/SalesComponent/Quote/AddComponent";
import CustomConfigurator from "../pages/SalesComponent/Quote/CustomConfigurator";
import Approvedcomp from "../pages/SalesComponent/Quote/Approvedcomp";
import Underapprovedcomp from "../pages/SalesComponent/Quote/Underapprovedcomp";
import Draftcomp from "../pages/SalesComponent/Quote/Draftcomp";
import CustomerComp from "../pages/SalesComponent/Funnel/CustomerComp";
import StatusComp from "../pages/SalesComponent/Funnel/StatusComp"; 
import Opencomp from "../pages/SalesComponent/Task/Opencomp";
import ToAssignComp from "../pages/SalesComponent/Task/ToAssignComp";
// --- reports
import AllReportsTab from "./reports/AllReportsTab";
import DispatchWiseTab from "./reports/DispatchWiseTab";
import DispenserRecordTab from "./reports/DispenserRecordTab";
// import ProductTab from "./reports/ProductTab";
import ServicesTab from "./reports/ServicesTab";
import WorkOrderTab from "./reports/WorkOrderTab";
import AboutUs from "../pages/examples/AboutUs";
import NonTechDashboard from "../pages/TicketServiceComp/TicketServiceDashboardComp/TicketnonTechDashboard"
import TechDashboard from "../pages/TicketServiceComp/TicketServiceDashboardComp/TicketTechDashbaord";
import TicketServiceNonTech from "../pages/TicketServiceComp/TicketServiceNonTech";
import RaiseTicketForm from "../pages/TicketServiceComp/RaiseTicket"
import TicketServiceTech from "../pages/TicketServiceComp/TicketServiceTech";
import ROCreate from "../pages/TicketServiceComp/RoOnboardingComp/ROCreate";
import RoGetlist from "../pages/TicketServiceComp/RoOnboardingComp/RoGetlist";
import EmployeeActivityTracker from "./activity-tracker/EmployeeActivityTracker";
import ManagerAnalytics from "./activity-tracker/ManagerAnalytics";
import axios from "axios";

export const isAuthenticated = (reduxprops) => {
  const token = sessionStorage.getItem("token");
  const loginStatus = sessionStorage.getItem("loginStatus");
  const hasToken = !!token && token !== "null" && token !== "undefined" && token !== "";
  const isLoggedStatus = loginStatus === "true" || loginStatus === true;
  const hasGeod = reduxprops?.geod?.title === true;
  return hasToken || isLoggedStatus || hasGeod;
};

export const isPermission = (accessLabel) => {
  if (!accessLabel) return true;
  const label = accessLabel.trim().toLowerCase();
  const userRole = (sessionStorage.getItem("role") || "").toLowerCase().trim();

  // Admin and back office have full access
  if (userRole === "admin" || userRole === "back office") return true;

  // Role-based access for Employee & Manager
  if (userRole === "employee" && (label === "open" || label === "task" || label === "activitytracker" || label === "activity-tracker")) {
    return true;
  }
  if (userRole === "manager" && (label === "to assign" || label === "open" || label === "task" || label === "activitytracker" || label === "activity-tracker")) {
    return true;
  }

  if (label === "activitytracker" || label === "activity-tracker") return true;
  const moduleString = sessionStorage.getItem("moduleName");
  if (!moduleString) return false;
  const modules = moduleString
    .split(",")
    .map((m) => m.trim().toLowerCase());

  // Direct match
  if (modules.includes(label)) return true;

  // Module group mappings and aliases
  if (label === "work-orderx" || label === "work order") {
    return modules.some((m) =>
      ["work-orderx", "work order", "woinstall", "wocalibration", "wofield issue"].includes(m)
    );
  }
  if (label === "services") {
    return modules.some((m) =>
      ["services", "seinstall", "secalibration", "sefieldissue", "sefield issue"].includes(m)
    );
  }
  if (label === "productionx" || label === "production") {
    return modules.some((m) => ["productionx", "production"].includes(m));
  }
  if (label === "dispatchx" || label === "dispatch") {
    return modules.some((m) => ["dispatchx", "dispatch"].includes(m));
  }
  if (label === "reports") {
    return modules.some((m) =>
      ["reports", "remaster", "redispatch", "reworkorder", "reservices", "redispboa"].includes(m)
    );
  }
  if (label === "dashboard") {
    return modules.some((m) =>
      ["dashboard", "nontech dashbaord", "nontech dashboard", "tech dashboard"].includes(m)
    );
  }
  return false;
};

export const getDefaultRoute = () => {
  const moduleString = sessionStorage.getItem("moduleName") || "";
  const modules = moduleString
    .split(",")
    .map((m) => m.trim().toLowerCase());

  // Dashboard
  if (modules.includes("dashboard")) return Routes.DashboardOverview.path;
  if (modules.includes("nontech dashbaord") || modules.includes("nontech dashboard")) return Routes.NonTechDashboard.path;
  if (modules.includes("tech dashboard")) return Routes.TechDashboard.path;

  // Work Order
  if (modules.some((m) => ["work order", "work-orderx", "woinstall"].includes(m))) return Routes.InstallationList.path;
  if (modules.includes("wocalibration")) return Routes.CalibrationList.path;
  if (modules.includes("wofield issue")) return Routes.FieldJobList.path;

  // Ticket Service
  if (modules.includes("nontech service")) return Routes.TicketServiceNonTech.path;
  if (modules.includes("tech service")) return Routes.TicketServiceTech.path;

  // RO onboarding
  if (modules.includes("ro onboard") || modules.includes("ro list")) return Routes.RoList.path;

  // Master Module
  if (modules.includes("access control")) return Routes.AccessControlTabs.path;
  if (modules.includes("customer entry")) return Routes.CustomerEntryReports.path;
  if (modules.includes("dealer entry")) return Routes.DealerEntryReports.path;
  if (modules.includes("user entry")) return Routes.UserEntryReports.path;

  // Production
  if (modules.some((m) => ["production", "productionx"].includes(m))) return Routes.ProductionList.path;

  // Dispatch
  if (modules.some((m) => ["dispatch", "dispatchx"].includes(m))) return Routes.DispatchList.path;

  // Services
  if (modules.some((m) => ["services", "seinstall"].includes(m))) return Routes.ListOfInstallation.path;
  if (modules.includes("secalibration")) return Routes.ListOfCalibration.path;
  if (modules.includes("sefieldissue") || modules.includes("sefield issue")) return Routes.ListofFieldIssue.path;

  // Sales tool
  if (modules.includes("configurator")) return Routes.Configutar.path;
  if (modules.includes("salescomponent")) return Routes.salesComponent.path;
  if (modules.includes("approved")) return Routes.Approvedcomp.path;
  if (modules.includes("underapproval")) return Routes.Underapprovedcomp.path;
  if (modules.includes("draft")) return Routes.Draftcomp.path;
  if (modules.includes("customer")) return Routes.CustomerComp.path;
  if (modules.includes("status")) return Routes.StatusComp.path;
  if (modules.includes("open")) return Routes.EmployeeActivityDashboard.path;
  if (modules.includes("to assign")) return Routes.ManagerAnalytics.path;

  // Reports
  if (modules.some((m) => ["reports", "remaster"].includes(m))) return Routes.AllReportsTab.path;
  if (modules.includes("redispatch")) return Routes.DispatchWiseTab.path;
  if (modules.includes("reworkorder")) return Routes.WorkOrderTab.path;
  if (modules.includes("reservices")) return Routes.ServicesTab.path;
  if (modules.includes("redispboa")) return Routes.DispenserRecordTab.path;

  // Role-based fallbacks
  const role = (sessionStorage.getItem("role") || "").toLowerCase().trim();
  if (role === "employee") return Routes.EmployeeActivityDashboard.path;
  if (role === "manager") return Routes.ManagerAnalytics.path;
  if (role.includes("nontech") || role.includes("non-tech")) return Routes.NonTechDashboard.path;
  if (role.includes("tech")) return Routes.TechDashboard.path;
  if (role.includes("service")) return Routes.ListOfInstallation.path;
  if (role.includes("sales")) return Routes.Draftcomp.path;
  if (role.includes("production")) return Routes.ProductionList.path;
  if (role.includes("dispatch")) return Routes.DispatchList.path;

  // Default fallback for logged in user is Dashboard
  return Routes.DashboardOverview.path;
};

const RouteWithLoader = ({ component: Component, reduxprops, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated(reduxprops) ? (
          <>
            <Preloader show={!loaded} />
            <Component {...props} />
          </>
        ) : (
          <Redirect to={getDefaultRoute()} />
        )
      }
    />
  );
};

const RouteWithSidebar = ({
  component: Component,
  reduxprops,
  accessLabel,
  ...rest
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const [showSettings, setShowSettings] = useState(
    sessionStorage.getItem("settingsVisible") !== "false"
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    sessionStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated(reduxprops) ? (
          isPermission(accessLabel) ? (
            <>
              <Sidebar />
              <main className="content">
                <Navbar />
                <Component {...props} />
                {/* <Footer toggleSettings={toggleSettings} showSettings={showSettings} /> */}
              </main>
            </>
          ) : (
            <Redirect to={getDefaultRoute()} />
          )
        ) : (
          <Redirect to={Routes.Signin.path} />
        )
      }
    />
  );
};

const RouteWithNavbar = ({ component: Component, reduxprops, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const [showSettings, setShowSettings] = useState(
    sessionStorage.getItem("settingsVisible") !== "false"
  );

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    sessionStorage.setItem("settingsVisible", !showSettings);
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated(reduxprops) ? (
          <>
            <Sidebar />
            <main className="content">
              <Navbar />
              <Component {...props} />
              {/* <Footer toggleSettings={toggleSettings} showSettings={showSettings} /> */}
            </main>
          </>
        ) : (
          <Redirect to={Routes.Signin.path} />
        )
      }
    />
  );
};

const HomePage = (props) => {
  const { geod, activateGeod } = props;
  const geodTitle = geod?.title;
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // If token exists in session storage, keep Redux state synchronized
    const token = sessionStorage.getItem("token");
    if (token && token !== "null" && token !== "undefined" && !geodTitle) {
      if (typeof activateGeod === "function") {
        activateGeod({ title: true });
      }
    }
  }, [geodTitle, activateGeod]);

  useEffect(() => {
    if (!isAuthenticated(props)) return;

    const authPaths = [
      Routes.Signin.path,
      Routes.SignMobile.path,
      Routes.ForgotPassword.path,
      Routes.ResetPassword.path,
      Routes.SignOtp.path,
    ];

    // If an authenticated user somehow lands on any login/auth route, redirect immediately to default route
    if (authPaths.includes(location.pathname)) {
      history.replace(getDefaultRoute());
      return;
    }

    // Trap history so browser back button cannot navigate out of the web page or to login page
    window.history.pushState(null, document.title, window.location.href);

    const handlePopState = () => {
      if (isAuthenticated(props)) {
        // Immediately push current state back to block back navigation outside the app
        window.history.pushState(null, document.title, window.location.href);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [geodTitle, location.pathname, history, props]);

  return (
    <Switch>
      {/* Public / Auth routes - if authenticated, redirect to default app route */}
      <RouteWithLoader exact path={Routes.Signin.path} reduxprops={props} component={Signin} />
      <RouteWithLoader exact path={Routes.SignMobile.path} reduxprops={props} component={SignMobile} />
      <RouteWithLoader exact path={Routes.ForgotPassword.path} reduxprops={props} component={ForgotPassword} />
      <RouteWithLoader exact path={Routes.ResetPassword.path} reduxprops={props} component={ResetPassword} />
      <RouteWithLoader exact path={Routes.SignOtp.path} reduxprops={props} component={SignOtp} />

      {/* Static / Public Pages */}
      <Route
        exact
        path={Routes.NotFound.path}
        render={(p) =>
          isAuthenticated(props) ? (
            <Redirect to={getDefaultRoute()} />
          ) : (
            <NotFoundPage {...p} />
          )
        }
      />
      <Route exact path={Routes.ServerError.path} reduxprops={props} component={ServerError} />
      <RouteWithNavbar exact path={Routes.AboutUs.path} reduxprops={props} component={AboutUs} />

      {/* Root Route: DashboardOverview */}
      <RouteWithSidebar
        exact
        path={Routes.DashboardOverview.path}
        reduxprops={props}
        component={DashboardOverview}
        accessLabel="Dashboard"
      />

      {/* Dashboard / modules */}
      <RouteWithSidebar exact path={Routes.NonTechDashboard.path} reduxprops={props} component={NonTechDashboard} accessLabel="nontech dashbaord" />
      <RouteWithSidebar exact path={Routes.TechDashboard.path} reduxprops={props} component={TechDashboard} accessLabel="tech dashboard" />

      {/* Master Module */}
      <RouteWithSidebar exact path={Routes.AccessControlTabs.path} reduxprops={props} component={AccessControlTabs} accessLabel="Access Control" />
      <RouteWithSidebar exact path={Routes.CustomerEntry.path} reduxprops={props} component={CustomerEntry} accessLabel="Customer Entry" />
      <RouteWithSidebar exact path={Routes.CustomerEntryReports.path} reduxprops={props} component={CustomerEntryReports} accessLabel="Customer Entry" />
      <RouteWithSidebar exact path={Routes.DealerEntry.path} reduxprops={props} component={DealerEntry} accessLabel="Dealer Entry" />
      <RouteWithSidebar exact path={Routes.DealerEntryReports.path} reduxprops={props} component={DealerEntryReports} accessLabel="Dealer Entry" />
      <RouteWithSidebar exact path={Routes.UserEntry.path} reduxprops={props} component={UserEntry} accessLabel="User Entry" />
      <RouteWithSidebar exact path={Routes.UserEntryReports.path} reduxprops={props} component={UserEntryReports} accessLabel="User Entry" />

      {/* Production */}
      <RouteWithSidebar exact path={Routes.ProductionList.path} reduxprops={props} component={ProductionList} accessLabel="Productionx" />
      <RouteWithSidebar exact path={Routes.AddProduction.path} reduxprops={props} component={AddProduction} accessLabel="Productionx" />

      {/* Dispatch */}
      <RouteWithSidebar exact path={Routes.DispatchList.path} reduxprops={props} component={DispatchList} accessLabel="Dispatchx" />
      <RouteWithSidebar exact path={Routes.AddDispatch.path} reduxprops={props} component={AddDispatch} accessLabel="Dispatchx" />

      {/* Work Order */}
      <RouteWithSidebar exact path={Routes.InstallationList.path} reduxprops={props} component={InstallationList} accessLabel="Work-Orderx" />
      <RouteWithSidebar exact path={Routes.Installation.path} reduxprops={props} component={Installation} accessLabel="Work-Orderx" />
      <RouteWithSidebar exact path={Routes.FieldJobList.path} reduxprops={props} component={FieldJobList} accessLabel="Work-Orderx" />
      <RouteWithSidebar exact path={Routes.FieldJob.path} reduxprops={props} component={FieldJob} accessLabel="Work-Orderx" />
      <RouteWithSidebar exact path={Routes.CalibrationList.path} reduxprops={props} component={CalibrationList} accessLabel="Work-Orderx" />
      <RouteWithSidebar exact path={Routes.Calibration.path} reduxprops={props} component={Calibration} accessLabel="Work-Orderx" />
      <RouteWithSidebar
        exact
        path={Routes.TicketServiceNonTech.path}
        component={TicketServiceNonTech}
        reduxprops={props}
        accessLabel="nontech service"
      />

      {/* Services */}
      <RouteWithSidebar exact path={Routes.ListOfInstallation.path} reduxprops={props} component={ListOfInstallation} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.GetDispenser.path} reduxprops={props} component={GetDispenser} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.ListofFieldIssue.path} reduxprops={props} component={ListofFieldIssue} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.GetFieldDispenser.path} reduxprops={props} component={GetFieldDispenser} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.VerificationFieldIssueList.path} reduxprops={props} component={VerificationFieldIssueList} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.ListOfCalibration.path} reduxprops={props} component={ListOfCalibration} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.GetCalibrationDispenser.path} reduxprops={props} component={GetCalibrationDispenser} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.VerificationCalibrationList.path} reduxprops={props} component={VerificationCalibrationList} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.ArkCalibrationList.path} reduxprops={props} component={ArkCalibrationList} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.ARKFailedCalibrationList.path} reduxprops={props} component={ARKFailedCalibrationList} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.VerificationInstallationList.path} reduxprops={props} component={VerificationInstallationList} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.ArkFieldList.path} reduxprops={props} component={ArkFieldList} accessLabel="Services" />
      <RouteWithSidebar exact path={Routes.EndingARKCalibration.path} reduxprops={props} component={EndingARKCalibration} accessLabel="Services" />

      {/* Reports */}
      <RouteWithSidebar exact path={Routes.AllReportsTab.path} reduxprops={props} component={AllReportsTab} accessLabel="Reports" />
      <RouteWithSidebar exact path={Routes.DispatchWiseTab.path} reduxprops={props} component={DispatchWiseTab} accessLabel="Reports" />
      <RouteWithSidebar exact path={Routes.WorkOrderTab.path} reduxprops={props} component={WorkOrderTab} accessLabel="Reports" />
      <RouteWithSidebar exact path={Routes.ServicesTab.path} reduxprops={props} component={ServicesTab} accessLabel="Reports" />
      <RouteWithSidebar exact path={Routes.DispenserRecordTab.path} reduxprops={props} component={DispenserRecordTab} accessLabel="Reports" />

      {/* Sales tool */}
      <RouteWithSidebar
        exact
        path={Routes.Configutar.path}
        component={Configutar}
        reduxprops={props}
        accessLabel="configurator"
      />
      <RouteWithSidebar
        exact
        path={Routes.CustomConfigurator?.path || "/mainqoute/configutar/custom"}
        component={CustomConfigurator}
        reduxprops={props}
        accessLabel="configurator"
      />
      <RouteWithSidebar
        exact
        path={Routes.salesComponent.path}
        component={salesAddComponent}
        reduxprops={props}
        accessLabel="salesComponent"
      />
      <RouteWithSidebar
        exact
        path={Routes.Approvedcomp.path}
        component={Approvedcomp}
        reduxprops={props}
        accessLabel="approved"
      />
      <RouteWithSidebar
        exact
        path={Routes.Underapprovedcomp.path}
        component={Underapprovedcomp}
        reduxprops={props}
        accessLabel="underApproval"
      />
      <RouteWithSidebar
        exact
        path={Routes.Draftcomp.path}
        component={Draftcomp}
        reduxprops={props}
        accessLabel="draft"
      />
      <RouteWithSidebar
        exact
        path={Routes.CustomerComp.path}
        component={CustomerComp}
        reduxprops={props}
        accessLabel="customer"
      />
      <RouteWithSidebar
        exact
        path={Routes.StatusComp.path}
        component={StatusComp}
        reduxprops={props}
        accessLabel="status"
      />
      <RouteWithSidebar
        exact
        path={Routes.Opencomp.path}
        component={Opencomp}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.ToAssignComp.path}
        component={ToAssignComp}
        reduxprops={props}
        accessLabel="to assign"
      />
      <RouteWithSidebar
        exact
        path={Routes.RaiseTicketForm.path}
        component={RaiseTicketForm}
        reduxprops={props}
        accessLabel="nontech service"
      />
      <RouteWithSidebar
        exact
        path={Routes.TicketServiceTech.path}
        component={TicketServiceTech}
        reduxprops={props}
        accessLabel="tech service"
      />
      <RouteWithSidebar
        exact
        path={Routes.RoOnboarding.path}
        component={ROCreate}
        reduxprops={props}
        accessLabel="Ro onboard"
      />
      <RouteWithSidebar
        exact
        path={Routes.RoList.path}
        component={RoGetlist}
        reduxprops={props}
        accessLabel="Ro List"
      />

      {/* Employee Activity Tracker */}
      <RouteWithSidebar
        exact
        path={Routes.EmployeeActivityTracker.path}
        component={EmployeeActivityTracker}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.EmployeeActivityDashboard.path}
        component={EmployeeActivityTracker}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.EmployeeAttendanceHistory.path}
        component={EmployeeActivityTracker}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.EmployeeActivityLogs.path}
        component={EmployeeActivityTracker}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.EmployeeBreakHistory.path}
        component={EmployeeActivityTracker}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.EmployeeTasks.path}
        component={EmployeeActivityTracker}
        reduxprops={props}
        accessLabel="open"
      />
      <RouteWithSidebar
        exact
        path={Routes.ManagerAnalytics.path}
        component={ManagerAnalytics}
        reduxprops={props}
        accessLabel="to assign"
      />

      {/* Catch-all fallback */}
      <Route
        render={() =>
          isAuthenticated(props) ? (
            <Redirect to={getDefaultRoute()} />
          ) : (
            <Redirect to={Routes.Signin.path} />
          )
        }
      />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  geod: state.geod,
});

const mapDispatchToProps = {
  activateGeod,
  closeGeod,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);


